import _ from "lodash";

export const processNode = (node) => {
  const [x, y] = node.position.split(",");
  return Object.assign({}, node, {
    type: "customNode",
    position: {
      x,
      y,
    },
  });
};

export const processEdge = (edge) => {
  return Object.assign({}, edge, {
    type: "customEdge",
    arrowHeadType: "arrowclosed",
  });
};

export const isEdge = (element) => element.id.includes("-");

export const getNode = (nodeId, graph) =>
  graph.nodes.find((n) => n.id === nodeId);

export const areNodesVisited = (nodes) => {
  for (const node of nodes) {
    if (_.get(node.data, "shortestPath", null) === null) {
      return false;
    }
  }
  return true;
};

export const getNextNode = ({ nodes, edges }) => {
  for (const node of nodes) {
    if (_.get(node.data, "shortestPath", null) !== null) {
      continue;
    }
    const predecessors = getPredecessorNodes(node.id, { nodes, edges });
    if (areNodesVisited(predecessors)) {
      return node;
    }
  }
  return null;
};

export const getPredecessorNodes = (nodeId, graph) =>
  graph.edges
    .filter((edge) => edge.target === nodeId)
    .map((edge) => graph.nodes.find((node) => node.id === edge.source));

export const getShortestPath = (nodeId, graph) => {
  let shortestPathLength = Infinity,
    shortestPathPredecessorId = -1;
  const predecessors = getPredecessorNodes(nodeId, graph);
  for (const edge of graph.edges) {
    if (edge.target === nodeId) {
      const currentPathLength =
        Number(edge.label) +
        predecessors.find((node) => node.id === edge.source).data.shortestPath;
      if (currentPathLength < shortestPathLength) {
        shortestPathLength = currentPathLength;
        shortestPathPredecessorId = edge.source;
      }
    }
  }
  return [shortestPathLength, shortestPathPredecessorId];
};

export const areAllNodesVisited = (graph) => {
  for (const node of graph.nodes) {
    if (node.data.shortestPath === undefined) {
      return false;
    }
  }
  return true;
};
